import { createClient } from "@supabase/supabase-js";

// Client browser-side, autenticado por magic link. Usa apenas a anon key — o
// service_role_key nunca é exposto ao bundle (ver design.md decisão 5). RLS
// (openspec/specs/banco-de-dados/spec.md) restringe o que este client consegue
// ler/escrever: leitura em agent_health/system_alerts para qualquer autenticado,
// leitura+escrita em human_approvals apenas para a role founder.
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // Supabase Auth por padrão expira a sessão de refresh token em 30 dias
      // no projeto (configurado no E02) — ver DASHBOARD_UI_SPECS.md/PIXEL_DASHBOARD.md.
    },
  },
);
